export default "__VITE_ASSET__BtW3TVHh__"